import { cn } from "@/lib/utils";

interface DropdownOptionProps {
  selected: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export function DropdownOption({
  selected,
  onClick,
  children,
}: DropdownOptionProps) {
  return (
    <button
      type="button"
      role="option"
      aria-selected={selected}
      onClick={onClick}
      className={cn(
        "w-full text-left px-3 py-2 rounded-lg text-sm transition-colors",
        selected
          ? "bg-brand-green-soft text-brand-green"
          : "hover:bg-raised",
      )}
    >
      {children}
    </button>
  );
}
